import { Fragment, h } from 'preact';
import PropTypes from 'prop-types';

import { IconAvatarPlaceholderEmpty, IconAvatarPlaceholderFilled } from '../../1-foundation/icons/icons';

const LoginBar = ({
  loginLabel,
  logoutLabel,
  onPersonalizeUrlClick,
  onLogin = () => { },
  onLogout = () => { },
  isLogged,
}) => {
  const IconAvatarPlaceholder = isLogged ? IconAvatarPlaceholderFilled : IconAvatarPlaceholderEmpty;
  const iconAvatarPlaceholderModifiers = isLogged
    ? ['mix', 'avatar-placeholder-filled', 'xsmall']
    : ['mix', 'avatar-placeholder-empty', 'xsmall'];

  return (
    <div className="c-login-bar">
      <Fragment>
        <div className="c-login-bar__separator" />
        <button type="button" className="c-login-bar__personalize" onClick={onPersonalizeUrlClick}>
          <div className="c-login-bar__personalize-icon">
            <IconAvatarPlaceholder modifiers={iconAvatarPlaceholderModifiers} />
          </div>
        </button>
        <div className="c-login-bar__separator" />
      </Fragment>
      <button
        className="c-login-bar__label"
        type="button"
        onClick={isLogged ? onLogout : onLogin}
        aria-label={isLogged ? logoutLabel : loginLabel}
      >
        {isLogged ? logoutLabel : loginLabel}
      </button>
    </div>
  );
};

LoginBar.propTypes = {
  loginLabel: PropTypes.string.isRequired,
  logoutLabel: PropTypes.string.isRequired,
  onLogin: PropTypes.func,
  onLogout: PropTypes.func,
  onPersonalizeUrlClick: PropTypes.func,
  isLogged: PropTypes.bool,
};

export default LoginBar;
